// A duration in minutes as people say it: 45 min · 3 h 20 min · 2 d 4 h.
// '–' when there is none.
export const formatDuration = (min) => {
    if (min === null || min === undefined || Number.isNaN(min)) return '–';
    // Round first, then split: 1139.6 min is "19 h", not "18 h 60 min".
    const total = Math.round(min);
    if (total < 60) return `${total} min`;
    if (total < 1440) {
        const h = Math.floor(total / 60), m = total % 60;
        return m ? `${h} h ${m} min` : `${h} h`;
    }
    const hours = Math.round(total / 60);
    const d = Math.floor(hours / 24), h = hours % 24;
    return h ? `${d} d ${h} h` : `${d} d`;
};
